import React from 'react';

const Layout: React.FC = ({ children }) => {
    return <div id="layout">{children}</div>;
};

export default Layout;
